<template>

  <div style="margin: 0 auto;width: 90%">

    <el-button type="default" size="small" @click="goBack()">返回 </el-button>
    <el-button type="primary" size="small" @click="goMoni()">再模拟一次</el-button>
    <el-table :data="stus" style="width: 100%;margin-top: 10px">
      <el-table-column prop="majorName" label="课程" width="180"></el-table-column>
      <el-table-column prop="score" label="分数" width="120"></el-table-column>
      <el-table-column prop="created_at" label="考试时间" width="180"></el-table-column>
      <el-table-column prop="publish" label="完成状态"></el-table-column>

      <el-table-column
          fixed="right"
          label="操作"
          width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleClick(scope.row)" v-if="scope.row.publish =='未完成'">继续考试</el-button>
          <el-button type="text" size="small" @click="handleView(scope.row)" v-if="scope.row.publish !='未完成'">查看明细</el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import {getTestRecord} from "@/api/moudles/user";

export default {
  name: "test_record",
  data(){
    return {

        major_id:'',
        scId:'',
        price_id:'',
        majorName:'',
        stus: []
      }

  },

  created() {
    document.title ='模拟考试'
    this.major_id = this.$route.query.major_id
    this.majorName = this.$route.query.majorName
    this.scId = this.$route.query.scId
    this.price_id = this.$route.query.priceId

    this.fetchData()
  },
  methods:{

    goMoni(){

      this.$router.push({
        path: '/test',
        query: {
          major_id: this.major_id,
          majorName: this.majorName,
          scId: this.scId,
          priceId:this.price_id
        }
      })

    },

    handleClick(row){

      this.$router.push({
        path: '/test',
        query: {
          major_id: row.major_id,
          majorName: row.majorName,
          examTempId: row.id,
        }
      })
    },

    goBack(){
      this.$router.go(-1)

    },

    handleView(row){
      this.$router.push({
        path: '/test_detail',
        query: {
          row: encodeURIComponent(JSON.stringify(row)),
        }
      })
    },

    fetchData(){
      let token = localStorage.getItem('userToken')

      getTestRecord({
        data: {
          majorId:this.major_id,
          scId:this.scId,
          price_id:this.price_id,
          token:token
        },
        success: (res) => {
          console.log(res)
          this.stus = res.data
        }
      })
    },
  }
}
</script>

<style scoped>

</style>